/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ datasetCategoryId: ZodTypes.Id });

export const AdminDatasetCategoryDelete = {
  id: 'admin-dataset-category.delete',
  tag: 'Admin',
  summary: 'Delete dataset category',
  description: 'Delete a dataset category',
  method: 'delete',
  flags: { isAuthorized: true, isSuperuser: true },
  route: (params: z.infer<typeof Params>) => `/administration/dataset-category/${params.datasetCategoryId}`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
